import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./PersonalData.css";

function PersonalDataPage() {
    return (
        <div className="app-container">
            <Sidebar />
            <main className="main-content">
                <h1 className="main-title">PersonalData Page</h1>
                <p className="main-description">Welcome to the PersonalData page!</p>
            </main>
        </div>
    );
}

export default PersonalDataPage;